import { JadeListItem, JadeTag, JadeDivider, JadeText } from '@jade'

import { statusTag } from '@utils/status-tag.utils'

export default {
  components: {
    JadeListItem,
    JadeTag,
    JadeDivider,
    JadeText
  },
  props: {
    source: Object,
    index: Number
  },
  computed: {
    hasLastItem () {
      return this.index === this.source.length - 1
    }
  },
  methods: {
    handleClick (id, name) {
      this.$router.push({
        name,
        params: {
          id
        }
      })
    },
    statusTag (code) {
      return statusTag(code)
    }
  }
}
